import * as angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngStorage from 'ngstorage';

import blocks from './blocks/blocks.module';
import core from './core/core.module';
import services from './services/services.module';
import modules from './modules/modules.module';
import components from './components/components.module';

angular.module('minto', [
    'minto.services',
    'minto.modules',
    'minto.components',
    'minto.blocks',
    'minto.core'
]).run(function ($rootScope, $location, $window) {
  // track routes
  $rootScope.$watch('userId', function () {
    $window.ga('create', 'UA-159953041-1', 'auto', {
      userId: $rootScope.userId
    });
    $window.ga('send', 'pageview', {page: $location.path()});
  })
  $rootScope.$on('$locationChangeSuccess', function (event) {
    if (!$window.ga)
      return;

    $window.ga('send', 'pageview', {page: $location.path()});
  });
});



// WEBPACK FOOTER //
// ./client/app/app.module.js